import {
  SaleCustomerGroupCreateBody,
  SaleCustomerGroupListResponse,
  SaleCustomerGroupItem,
  SaleCustomerGroupDetailResponse,
} from "utils/api/client/types"

export type ImportCustomerResult = {
  total: number
  matched: number
  added: number
  notFound: string[]
}

export class SaleCustomerGroup {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    vendorId: string,
    body: SaleCustomerGroupCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<{ data: SaleCustomerGroupItem }> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-customer-group`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  update(
    id: string,
    vendorId: string,
    body: SaleCustomerGroupCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SaleCustomerGroupItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-customer-group/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SaleCustomerGroupListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-customer-group`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SaleCustomerGroupDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-customer-group/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  importCustomers(
    vendorId: string,
    groupId: string,
    body: FormData
  ): Promise<{ data: ImportCustomerResult }> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-customer-group/${groupId}/import-customers`,
        {
          method: "POST",
          body,
          // Let the browser set the multipart boundary itself.
          headers: { "content-type": null },
        }
      )
    })()
  }

  delete(
    id: string | number,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-customer-group/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
